import { createContext, FC, useState } from 'react';
import { UserInfo } from '../service/user-service';

export type UserContextProps = {
  nickName: string;
  userId: string;
  role: string;
  updateUserInfo: React.Dispatch<React.SetStateAction<UserInfo>>;
};

export const UserContext = createContext<UserContextProps>(null as any);

type Props = {
  children: React.ReactNode;
};
const UserProvider: FC<Props> = ({ children }) => {
  const [userInfo, setUserInfo] = useState<UserInfo>({
    userId: '',
    nickName: '',
    role: ''
  });

  return (
    <UserContext.Provider
      value={{
        ...userInfo,
        updateUserInfo: setUserInfo
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
export default UserProvider;
